import React from "react";

interface SelectOption {
    value: string;
    label: string;
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    options: SelectOption[];
    placeholder?: string;
}

const Select: React.FC<SelectProps> = ({
                                           options,
                                           placeholder = "Выберите значение",
                                           className = "",
                                           ...props
                                       }) => {
    return (
        <select className={`ui-select ${className}`.trim()} {...props}>
            <option value="">{placeholder}</option>
            {options.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default Select;
